module.exports = "/_next/static/images/flox-9a743316c0e60fdc69f2fc7f5caf6ad1.png";